
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {FormBuilder } from '@angular/forms';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';
import { IPromotion, Promotion } from '../../../../../models/promotion.model';

import { Location } from '@angular/common';

import { PrivateSpaceService } from '../../../../../services/privateSpace.service';
import { IPrivateSpace } from '../../../../../models/privateSpace.model';
import { User } from '../../../../../models/user.model';

@Component({
  selector: 'app-customer-space',
  templateUrl: './customer-space.component.html',
  styleUrls: ['./customer-space.component.scss']
})
export class CustomerSpaceComponent implements OnInit {

 
  @ViewChild('closebutton1') closebutton1;
  search: any;
  allPrivateSpaces: IPrivateSpace[] = [];
  allPrivateSpacesTmp: IPrivateSpace[] = [];

  // @ts-ignore
  currentPrivateSpace: IPromotion = [];
  page = 1;
  sorted = false;
  sorted1 = false;
  sorted2 = false;
  sorted3 = false;
  sorted4 = false;
  isTrueName = false;
  privateSpaceId : number
  privateSpace : IPrivateSpace
  userInPrivateSpace: User [] 
  userInPrivateSpacetmp: User [] 
  userManagerForSpace: User []
  perPage: number = 32;
  totalItems: number = 1000;
  currentPage: number = 1;
  totalPages!: number;
  @ViewChild('closebutton') closebutton;

  constructor(private route: ActivatedRoute,private privateSpaceService: PrivateSpaceService, private fb: FormBuilder,
              private router :Router,private location: Location,
             ) { }

  ngOnInit(): void {
    this.loadPrivateSpace();
    this.privateSpaceId = Number(this.route.snapshot.paramMap.get('id'));

    // console.log("l'id de l private space", this.privateSpaceId)

    this.getPrivateSpaceById();
  }

  


  goBack(): void {
    this.location.back();
  }

  disableButton = true;


 

  selectedStartDate : any;
  selectedEndDate : any;
  startDateNotAfterEndDate = false;
  endDateNotAfterStartDate = false;
  startDateNotEqualsEndDate = false;


  showPicker: boolean = true;
  selectedDateTime: string | null = null;

  closePicker() {
    // Handle any logic you need with the selectedDateTime
    this.showPicker = false;
  }

  closeDatetimePicker(inputElement: ElementRef) {
      inputElement.nativeElement.blur();
  }



  reloadComponent() {
    let currentUrl = this.router.url;
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([currentUrl]);
  }








  validateStartDates(startDate: any): string | null {
    const currentDate = new Date();
    const startDateTime = new Date(startDate);
    const oneHourInMilliseconds = 60 * 60 * 1000;
    if (startDateTime.getTime() - currentDate.getTime() >= oneHourInMilliseconds) {
      return 'La date de début est supérieure d\'une heure ou plus à la date d\'aujourd\'hui';
    }
    return null;
  }

  validateEndDates(endDate: any): string | null {
    const currentDate = new Date();
    const endDateTime = new Date(endDate);

    if (endDateTime < currentDate) {
      return 'La date de fin est dépassée';
    }
    return null;
  }


  loadPrivateSpace(){
    this.allPrivateSpace(this.currentPage);
  }

  allPrivateSpace = (page: number)=>{
    this.privateSpaceService.getPrivateSpaceOld(page-1, this.perPage).subscribe(pr=>{
        this.allPrivateSpaces = pr.content;
        this.allPrivateSpacesTmp = pr.content;
        this.totalItems = pr.totalElements;
        this.perPage = pr.size;
        this.totalPages = pr.totalPages;
        // console.log("Annonce en promotions");
        // console.log(this.allPrivateSpaces);
      });
}


getPrivateSpaceById(){
  this.privateSpaceService.getIdPrivateSpace(this.privateSpaceId).subscribe(data => {
    this.privateSpace = data;
    // console.log("l'espace privé")
  // console.log(this.privateSpace)
  this.userInPrivateSpace = this.privateSpace.customers
  this.userInPrivateSpacetmp = this.privateSpace.customers
  this.userManagerForSpace = this.privateSpace.managers
  // console.log("les user associé")
  // console.log(this.userInPrivateSpace)
  })
}

ifUserManager(id: any): boolean {
  return !!id && this.userManagerForSpace?.some(manager => manager.id === id) || false;
}


  displayPerPage(value: any) {
    this.perPage = parseInt(value, 10);
   // // console.log(this.perPage);
  }


  close() {
    this.closebutton.nativeElement.click();
  }

  close1() {
    this.closebutton1.nativeElement.click();
  }

  sort2() {
    if(this.sorted == false) {
      // @ts-ignore
      this.allPrivateSpaces.sort((a, b) => a.seller.lastname > b.seller.lastname ? 1 : a.seller.lastname < b.seller.lastname ? -1 : 0)
      this.sorted = true;
    } else {
      // @ts-ignore
      this.allPrivateSpaces.sort((a, b) => a.seller.lastname < b.seller.lastname ? 1 : a.seller.lastname > b.seller.lastname ? -1 : 0)
      this.sorted = false;
    }
  }

  sort1() {
    if(this.sorted1 == false) {
      // @ts-ignore
      this.allPrivateSpaces.sort((a, b) => a?.name > b?.name ? 1 : a?.name < b?.name ? -1 : 0)
      this.sorted1 = true;
    } else {
      // @ts-ignore
      this.allPrivateSpaces.sort((a, b) => a?.name < b?.name ? 1 : a?.name > b?.name ? -1 : 0)
      this.sorted1 = false;
    }
  }

  sort3() {
    if(this.sorted2 == false) {
      // @ts-ignore
      this.allPrivateSpaces.sort((a, b) => a.createdAt > b.createdAt ? 1 : a.createdAt < b.createdAt ? -1 : 0)
      this.sorted2 = true;
    } else {
      // @ts-ignore
      this.allPrivateSpaces.sort((a, b) => a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0)
      this.sorted2 = false;
    }
  }

  

 

  copied = false;
  copiedCode: string = ''; // Ajoutez cette ligne pour stocker le code promo copié

  copyToClipboard(content: string) {
    const textArea = document.createElement('textarea');
    textArea.value = content;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);

    this.copied = true;
    this.copiedCode = content; // Stocke le code promo copié

    setTimeout(() => {
      this.copied = false;
      this.copiedCode = ''; // Réinitialiser après un délai
    }, 2000);
  }


  searchFilter($event: KeyboardEvent) {
    this.userInPrivateSpace =  this.userInPrivateSpacetmp.filter(
      value => value.firstname?.toLowerCase().includes(this.search) ||
      value.lastname.toString().includes(this.search)
     
     
    );
  }







addManagerToSpace(userId: any): void{
    

    this.privateSpaceService.addManagerForPrivateSpace(this.privateSpaceId, userId).subscribe(rs=>{
      this.reloadComponent();
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Utilisateur ajouté avec succès.',
        showConfirmButton: false,
        timer: 1500
      });
    }, error => {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Erreur d\'ajout <br>'+error.error.errorMessage,
        showConfirmButton: false,
        timer: 5000
      })
    });
  
   
}

removeManagerToSpace(userId: String,id:any){
  Swal.fire({
    title: 'Voulez-vous vraiment supprimer cet utilisateur des gestionnaires ?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonText: 'Non',
    confirmButtonText: 'Oui'
  }).then((result) => {
    if (result.isConfirmed) {
      this.privateSpaceService.removeManagerForPrivateSpace(this.privateSpaceId, userId).subscribe(
        rs=> {

          // // console.log("Response de la suppression")
          // // console.log(rs)
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Utilisateur supprimé de la liste avec succès.',
            showConfirmButton: false,
            timer: 1500
          });
          
            this.reloadComponent();
          
          
        }, error => {
          // // console.log(error);
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: error.error.errorMessage,
            showConfirmButton: false,
            timer: 5500
          })
        }
      )
    }
  })

}

removeCustomerToSpace(userId: String){
  Swal.fire({
    title: 'Voulez-vous vraiment supprimer cet utilisateur de l\'espace ?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonText: 'Non',
    confirmButtonText: 'Oui'
  }).then((result) => {
    if (result.isConfirmed) {
      this.privateSpaceService.removeCustomerToPrivateSpace(this.privateSpaceId, userId).subscribe(
        rs=> {

          // // console.log("Response de la suppression")
          // // console.log(rs)
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Utilisateur supprimé de la liste avec succès.',
            showConfirmButton: false,
            timer: 1500
          });
          this.reloadComponent();
        }, error => {
          // // console.log(error);
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: error.error.errorMessage,
            showConfirmButton: false,
            timer: 5500
          })
        }
      )
    }
  })

}
}
